export default "__VITE_ASSET__iKG1biJB__"